import type { Node as ProseMirrorNode } from '@tiptap/pm/model';
import type { Transaction } from '@tiptap/pm/state';

export const VARIABLE_NODE_NAME = 'variable';

type VariableNodeSnapshot = {
  attrs: Record<string, unknown>;
};

function collectVariableNodes(doc: ProseMirrorNode): VariableNodeSnapshot[] {
  const nodes: VariableNodeSnapshot[] = [];
  doc.descendants((node) => {
    if (node.type.name === VARIABLE_NODE_NAME) {
      nodes.push({ attrs: node.attrs });
    }
  });
  return nodes;
}

/**
 * True when a transaction inserted, removed, or changed the attrs of a
 * `variable` chip node. Used to flush a debounced cell commit synchronously
 * for chip transactions, so a stale pre-insert commit can't fire later and
 * overwrite the re-derived state.
 */
export function transactionTouchesVariableNode(transaction: Transaction): boolean {
  if (!transaction.docChanged) return false;

  const before = collectVariableNodes(transaction.before);
  const after = collectVariableNodes(transaction.doc);

  if (before.length !== after.length) return true;

  return after.some((node, index) => JSON.stringify(before[index]?.attrs) !== JSON.stringify(node.attrs));
}
